import {mapState} from 'vuex'
import * as workerTimers from 'worker-timers';
export default {
	name: "WorkersStyles",
	data() {
		return {
			icons_loaded: false,
			asset_animation: {},
			flash_color: {
				'danger': '255, 0, 0',
				'light': '0,255,0',
				'buzz': '0, 255, 50'
			},
			fill_color: {
				'danger': 'red',
				'light': '#33FF36',
				'buzz': '#33FF36'
			}
		}
	},
	computed: {
		...mapState([
			'filteredWorkers',
			'floor_level',
			'features',
			'workers',
			'watcher',
			'sprites',
			'vehicles',
			'vehicle_sprites'
		]),
		map() { return this.$store.state.map.map },
		flash() { return this.$store.state.flash }
	},
	mounted() {
		this.map.getView().on('change:resolution', () => {
			this.workersVisibility();
			this.vehiclesVisibility();
		});
	},
	watch: {
		flash: {
			handler() {
				this.workersVisibility();
				this.vehiclesVisibility();
				for (let i in this.workers) {
					this.flashAsset(this.workers[i]);
				}
				for (let i in this.vehicles) {
					this.flashAsset(this.vehicles[i]);
				}
			},
			deep: true
		},
		floor_level() {
			this.workersVisibility();
			for (let i in this.workers) {
				this.flashAsset(this.workers[i]);
			}
		},
		workers: {
			handler() {
				this.workersVisibility();
				for (let i in this.workers) {
					this.flashAsset(this.workers[i]);
				}
			},
			deep: true
		},
		vehicles: {
			handler() {
				this.vehiclesVisibility();
				for (let i in this.vehicles) {
					this.flashAsset(this.vehicles[i]);
				}
			},
			deep: true
		}
	},
	methods: {
		workersVisibility() {
			for (let i in this.workers) {
				let worker = this.workers[i];
				let $sprite = this.sprites[worker.id];
				$sprite.setStyle(this.workerStyle(worker));
			}
		},
		vehiclesVisibility() {
			for (let i in this.vehicles) {
				let worker = this.vehicles[i];
				let $sprite = this.vehicle_sprites[worker.id];
				$sprite.setStyle(this.workerStyle(worker));
			}
		},
		workerStyle(worker) {
			let styles = [];
			let assetType = "people";
			if (this.vehicle_types[worker.type] !== undefined) assetType = "vehicle";

			if (
				worker.end ||
				(worker.floor_level != this.floor_level && this.floor_level != "*") ||
				worker.filtered === true
			) {
				let z_index = (assetType == 'vehicle' ? -2 : -1 );
				styles.push(
					new ol.style.Style({
						zIndex: z_index
					})
				);
				return styles;
			}


			let bg_color = worker.company.bg_color || "#000";


			let color = "#000";
			if (worker.job) {
				color = this.$config.icon_class[this.$config.job_types[worker.job].class] ||
				"#000";
			}
			else if (worker.color) {
				color = worker.color
			}


			//worker.$sprite.scale = 0.01;
			let $sprite;
			if (assetType == "vehicle") $sprite = this.vehicle_sprites[worker.id];
			else $sprite = this.sprites[worker.id];
			let radius = $sprite.size * $sprite.scale;
			if (this.map.getView().getZoom() <= 17) {
				radius = radius * 0.5;
			}
			let stroke = new ol.style.Stroke({
				color: "#fff",
				width: 1
			});
			let fill = new ol.style.Fill({color: bg_color});

			let worker_flash = this.flash[worker.id];
			if (!worker_flash) {
				if (worker.alert == true) worker_flash = { id: worker.id, flash: 'danger', duration: null}
			}
			if (worker_flash) {
				fill.setColor(this.fill_color[worker_flash.flash]);
			}

			let shape_style =
				assetType === "people" ?
				new ol.style.Style({
					image: new ol.style.Circle({
						radius: radius / 1.5,
						stroke,
						fill
					}),
					zIndex: 20
				}) :
				new ol.style.Style({
					image: new ol.style.RegularShape({
						fill,
						stroke,
						points: 4,
						radius: radius,
						angle: Math.PI / 4
					}),
					zIndex: 10
				});

			styles.push(shape_style);

			let icon_color = color;
			if (worker.alert === true) icon_color = "#fff";

			if (this.map.getView().getZoom() > 17) {
				let icon_img;
				if (worker.img) icon_img = require(`assets/img/sprites/${worker.img}`);
				else icon_img = require(`assets/img/sprites/${this.$config.job_types[worker.job].img}`);

				let z_index = (assetType == 'vehicle' ? 11 : 21);
				let icon_style = new ol.style.Style({
					image: new ol.style.Icon({
						size: [$sprite.size, $sprite.size],
						scale: $sprite.scale,
						src: icon_img,
						color: icon_color
					}),
					zIndex: z_index
				});
				styles.push(icon_style);
			}

			return styles;
		},
		flashAsset (worker) {
			let worker_flash = this.flash[worker.id];
			let $sprite;
			let assetType = "people";
			if (this.vehicle_types[worker.type] !== undefined) assetType = "vehicle";
			if (assetType == "vehicle") $sprite = this.vehicle_sprites[worker.id];
			else $sprite = this.sprites[worker.id];

			if (this.asset_animation[worker.id] !== undefined) {
				this.assetsLayer.removeFeature(this.asset_animation[worker.id].feature);
				if (this.asset_animation[worker.id].to) workerTimers.clearTimeout(this.asset_animation[worker.id].to);
				this.asset_animation[worker.id] = undefined;
			}
			if (worker.floor_level != this.floor_level || worker.filtered === true) return;
			if (!worker_flash) {
				if (worker.alert == true) worker_flash = { id: worker.id, flash: 'danger', duration: null}
			}

			if (!worker_flash) return;
			var feature = this.assetsLayer.getFeatureById(worker.id);
			if (!feature) return;

			this.asset_animation[worker.id] = {
				start: new Date().getTime(),
				duration: worker_flash.duration,
				cycle: 3000,
				feature: null,
				to: null
			}
			let animation = this.asset_animation[worker.id];

			if (animation.feature == null) {
				animation.feature = feature.clone();
				this.assetsLayer.addFeature(animation.feature);
			} else {

			}


			const that = this;


			animate(worker, $sprite, animation)
			function animate(worker, $sprite, animation) {
				var elapsed = (new Date().getTime() - animation.start) % animation.cycle;
				var elapsedRatio = elapsed / animation.cycle;
				//					// radius will be 5 at start and 30 at end.
				var radius = ol.easing.easeOut(elapsedRatio) * 5 + ($sprite.size * $sprite.scale);
				var opacity = ol.easing.easeOut(1 - elapsedRatio);

				if (elapsed <= animation.cycle) {
					var style = new ol.style.Style({
						image: new ol.style.Circle({
							radius: radius,
							stroke: new ol.style.Stroke({
								color: 'rgba(' + (that.flash_color[worker_flash.flash] || '255, 0, 0') + ', ' + opacity + ')',
								width: 0.25 + opacity
							})
						})
					});
					animation.feature.setStyle(style);
				}

				animation.feature.getGeometry().setCoordinates(feature.getGeometry().getCoordinates());

				if (animation.duration != null && (new Date().getTime() - animation.start) > animation.duration) {
					that.flash[worker.id] = null;
				}
				else animation.to = workerTimers.setTimeout(function() { animate(worker, $sprite, animation); }, 200);
			}
		}
	}
};
